export enum ERateOurEstimationActions {
  SET_USER_PRICE = 'rateOurEstimation/setUserPrice',
  SET_COMMENT = 'rateOurEstimation/setComment',
  SET_RATE_OUR_ESTIMATION = 'rateOurEstimation/setRateOurEstimation',
  SET_IS_SCORE_FACT = 'rateOurEstimation/setIsScoreFact',
  TOGGLE_MODAL = 'rateOurEstimation/toggleModal',
  SET_SCREEN = 'rateOurEstimation/setScreen',
  TOGGLE_LOADING = 'rateOurEstimation/toggleLoading',
  TOGGLE_LOADING_BLOCK = 'rateOurEstimation/toggleLoadingBlock',
}
